import type { FaireProductEntity } from "../../entity_types/product";

export const p_ebodcwl549: FaireProductEntity = {
  token: "p_ebodcwl549",
  type: "product",
  name: "Lavender Gift Set",
  brandToken: "b_9rm92yvm",
  brandName: "White Rock Soap Gallery",
  imageUrl:
    "https://cdn.faire.com/fastly/212bbb6adc5babba8ae752c97f2994f3e82a090848a97e9f520dfb5f109f0bb2.jpeg",
  galleryImageUrls: [],
  priceDollars: 24,
  description:
    "This Lavender gift set makes a perfect gift for anybody and for any occasion. Gift box comes complete with a bow to make gift giving easy.\n\n𝐆𝐢𝐟𝐭 𝐬𝐞𝐭 𝐜𝐨𝐧𝐭𝐚𝐢𝐧𝐬:\n• Lavender Vanilla Soap\n• Sisal Soap Pouch\n• Lavender Soy Wax Candle\n• Lavender Linen Spray\n• Lavender Vanilla Sugar Scrub Mini\n• Lavender Lotion Bar\n• Lip Balm\n• and a box of Matches",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:14.143Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
